<template>
  <div class="carousel-container" :style="carouselStyl" ref="swiperContainRef">
    <div class="slider">
      <!-- specialData.swiperSpeed -->
      <el-carousel
        :interval="Number(specialData.swiperSpeed)"
        :width="imageWidth"
        :type="carouselType"
        :initial-index="currentIndex"
        :indicator-position="isShowPosition"
        :arrow="isShowArrow"
        :height="carouselHeight + 'px'"
        @change="changeIndex"
      >
        <el-carousel-item v-for="(item, index) in articleDataList" :key="item.id">
          <div @mouseover="overSwiperItem(item)" @click="clickSwiperItem(item)" :class="`img-box${receiveProps.blockInstanceId}${index} img-container`" :style="imgBoxStyl"></div>
          <img class="overly-btn" src="../asset/images/video-btn.png"
          v-if="item.fileType == 2 || item.selectType == 2">
          <div class="carousel-title" v-if="specialData.swiperTitleStatus">
            <span>{{item.swiperTitle}}</span>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import { commonClickFn } from "./componentArticle/commonModuleFn";
export default {
  name: "Carousel",
  props: {
    receiveProps: {
      type: [Object, Array],
      default: () => {}
    },
  },
  data() {
    return {
      carouselHeight: 300,  // 轮播高度
      imgBoxHeight: "", // 图片大小
      currentIndex: 0, // 轮播图索引
      carouselType: "1", // 轮播图类型 1 正常 2卡片
      specialData: this.receiveProps.tempData.specialData,
      specialStyle: this.receiveProps.tempData.specialStyle,
      articleDataList: this.receiveProps.tempData.specialEntryList,
      carouselInterval: '', // 轮播速度
      isShowPosition: '', //是否显示索引Position
      isShowArrow: 'hover', // 是否显示左右切换箭头
      isShowPointer: false, // 是否显示手指
      imageWidth: '' // 图片宽度
    };
  },
  mounted() {
    let { swiperType, swiperWrap } = this.specialData
    this.carouselType = swiperType == 2? 'card': '' // 空   card
    this.imageWidth = swiperWrap == 1? '1200px' : `${this.$refs.swiperContainRef.clientWidth}px`
    swiperType == 2 && (this.imageWidth = '1200px')
    this.isShowArrow = 'hover'
    this.articleDataList.length<2 && (this.isShowPosition = 'none', this.isShowArrow = 'never') // 判断少于两个轮播图的时候不显示索引Position 切换btn
    this.$nextTick(()=>{
      this.changeIndex(0);
      this.getImageInfoList()
    })
    
  },
  computed:{
      carouselStyl(){
          let { swiperWrap, swiperType} = this.specialData
          let {blockMargeTop, blockMargeBottom, imgBackgroundColor} = this.specialStyle
          return {
              maxWidth: swiperWrap == 1 ? "1200px" : "100%",
              width: swiperType == 2? '1200px': '',
            //   height: swiperWrap == 1 ? `${swiperHeight}px` : "",
              marginTop: `${blockMargeTop}px`,
              marginBottom: `${blockMargeBottom}px`,
              backgroundColor: imgBackgroundColor
          }
      },
      imgBoxStyl(){
        return {
          "--img-box-hover": this.isShowPointer? 'pointer': ''
        }
      }
  },
  methods: {
    changeIndex(val) {
      this.$nextTick(() => {
        this.changeImgSizeFn(this.articleDataList[val].image, `img-box${this.receiveProps.blockInstanceId}${val}`, this.$refs.swiperContainRef.clientWidth);
      });
    },
    clickSwiperItem(item) {
      commonClickFn(item, "", this, true);
    },
    changeImgSizeFn(url, className, imgWidthSize) {
      let _this = this;
      // if (this.specialData.swiperWrap == 1) return;
      var img = new Image();
      img.src = url;
      let cardCarouselWidth = ''
      let res = {};
      img.onload = function () {
        res = {
          width: img.width,
          height: img.height,
        };
        let realHeight =
          res.width < imgWidthSize
            ? res.height
            : (imgWidthSize / res.width) * res.height;
        _this.specialData.swiperWrap == 1 && (realHeight = _this.specialData.swiperHeight)
        _this.specialData.swiperType == 2 && (cardCarouselWidth = '1000px', realHeight = 450)
        _this.carouselHeight = realHeight;
        document.getElementsByClassName(className)[0].innerHTML = `<img src="${img.src}"  style=" width: ${cardCarouselWidth};max-width: ${this.imageWidth};height: ${realHeight}px">`
      };
    },
    getImageInfoList(){
      let idList = []
      this.articleDataList.map((item)=>{
      idList.push(item.fileId||item.articleId)
    })
      this.$apipcs.news.getImageList(idList).then(res=>{
      let ImageInfoList = res.data
      this.articleDataList.map((item,index)=>{
        ImageInfoList[index]&&(item.entryImg = ImageInfoList[index].thumbnail)
        ImageInfoList[index]&&(item.videoUrl = ImageInfoList[index].url)
        this.changeImgSizeFn(
        item.thumbnail,
        `img-box${this.receiveProps.blockInstanceId}${index}`,
        this.$refs.swiperContainRef.clientWidth
      );
      })

    })
    },
    overSwiperItem(item) {
      let { selectUrlType } = item;
      if (selectUrlType) {
        this.isShowPointer = true;
        return;
      }
      this.isShowPointer = false;
    },
  },
};
</script>

<style lang="less" scoped>
.carousel-container {
  max-width: 100%;
  text-align: center;
  margin: 0 auto;
  position: relative;
  .overly-btn{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 120px;
    height: 120px;
  }
  .img-container{
    &:hover{
      cursor: var(--img-box-hover);
    }
  }
  .carousel-title{
    position: absolute;
    bottom: 0;
    left: 0;
    height: 32px;
    width: 100%;
    background: rgba(0, 0, 0, 0.7);
    text-align: left;
    line-height: 32px;
    padding-left: 8px;
    box-sizing: border-box;
    span{
      font: 400 16px PingFangSC-Regular, PingFang SC;
      color: #fff;
    }
  }
  /deep/ .el-carousel__indicators{
    width: 100%;

    .el-carousel__button{
    width: 8px;
    height: 8px;
    border-radius: 50%;
    }
  } 
  /deep/ .el-carousel--card {
    .el-carousel__container{
      .is-active{
      width: 1000px;
      transform: translateX(100px) scale(1)!important;
    }
    }
    
  }
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  height: auto;
  margin: 0;
}
</style>